import AccordionHTML from "@components/accordions/accordionHTML";
import { ReactNode } from "react";
import { RaffleDefaultNumberHowItWorksDrawLottery } from "./draw-lottery";
import { RaffleDefaultNumberHowItWorksDrawRandom } from "./draw-random";

export function RaffleDefaultNumberHowItWorksDraws() {
  const items: { title: string; html: ReactNode }[] = [
    {
      title: "Loteria Federal",
      html: RaffleDefaultNumberHowItWorksDrawLottery(),
    },
    {
      title: "Sorteio Aleatório",
      html: RaffleDefaultNumberHowItWorksDrawRandom(),
    },
  ];

  return (
    <>
      <h5>Como é sorteado o ganhador da rifa?</h5>
      <p>
        Para este tipo de rifa, numérico, recomendamos duas modalidades, sendo
        elas como abaixo:
      </p>
      <div className="row">
        {/* Load the Explanations */}
        <AccordionHTML items={items} autoOpenKey={undefined} />
      </div>
    </>
  );
}
